import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { TranslateModule } from '@ngx-translate/core';

import { HardwareFaultLevelEffects } from './effects/hardware-fault-level.effects';
import { HardwareFaultCodeEffects } from './effects/hardware-fault-code.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    // 💡 核心修正：提供子模組專用的多國語系服務，解決 No provider 報錯
    TranslateModule.forChild(),
    // 💡 核心修正：將 Effect 註冊從 Root 移至 Feature 層級
    EffectsModule.forFeature([
      HardwareFaultLevelEffects,
      HardwareFaultCodeEffects
    ])
  ]
})
export class HardwareModule { }